import React from 'react';

// Components

import TextInput from '../../../UI/FormInput/TextInput';

export default function LocaleTypeFields({formik}) {
  return (
    <>
        {(formik.values?.direccion?.tipoInmueble === '1' || formik.values?.direccion?.tipoInmueble === '2') ? (
        <>
            <TextInput
                formik={formik}
                fieldName={'direccion.nivel'}
                label={'Nivel'}
                maxLength={5}
                isRequired={true}
            />
        </>
        ) : (formik.values?.direccion?.tipoInmueble === '3' || formik.values?.direccion?.tipoInmueble === '5') ? (
        <>
            <TextInput
                formik={formik}
                fieldName={'direccion.torre'}
                label={'Torre'}
                maxLength={80}
                isRequired={true}
            />

            <TextInput
              formik={formik}
              fieldName={'direccion.piso'}
              label={'Piso'}
              maxLength={5}
              isRequired={true}
            />

            <TextInput
                formik={formik}
                fieldName={'direccion.apartamento'}
                label={'Apartamento'}
                maxLength={5}
                isRequired={true}
            />
        </>
        ) : (null)}
    </>
  )
}
